import '../App.css';
import React from 'react';
import Logo from '../Images/ISC-PropEX-logo.png';
 const Navbar = () =>{
     return(
         <>
         <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top" style={{background:"#fff",padding:"20px"}}>
      <div className="container">
        <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}><img src={Logo} className="logo" /></a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ml-auto">
            
            <li className="nav-item">
              <a className="nav-link border-left-none" href={`${process.env.PUBLIC_URL}/#about`}>About <br className="mobile-hide"/>ISC PropEX</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={`${process.env.PUBLIC_URL}/#propertyExchange`}>Property <br className="mobile-hide"/>Exchange</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={`${process.env.PUBLIC_URL}/property-screening`}>Property <br className="mobile-hide"/>Screening</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={`${process.env.PUBLIC_URL}/property-list`}>Property Sales <br className="mobile-hide"/>and Listing</a>
            </li>
            <li className="nav-item align-nav-center">
              <a className="nav-link last" href={`${process.env.PUBLIC_URL}/#contact`}>Contact</a>
            </li>
            
          </ul>
        </div>
        </div>
    </nav>
    </>
     )
 }
 export default Navbar;